import { takeLatest, call, select, takeEvery, takeLeading } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  fetchBuyItAgainProducts,
  fetchBiaPageProducts,
  getMoreBuyItAgainProducts,
} from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.saga';
import {
  buyItAgainProducts,
  getPageProducts,
} from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.selectors';

import BUY_IT_AGAIN_BAG_PAGE_CONSTANTS from './BuyItAgainBagPage.constants';
import { getBIABagpageConfigData } from '../../../../../reduxStore/selectors/session.selectors';

export function* fetchBuyItAgainBagPageProducts() {
  try {
    // const biaDynamicData = yield select(getBIADynamicData);
    const biaConfigData = yield select(getBIABagpageConfigData);
    const biaProducts = yield select(buyItAgainProducts);
    if (biaProducts?.length <= 0 && biaConfigData) {
      yield call(fetchBuyItAgainProducts, { payload: biaConfigData });
    }
  } catch (error) {
    logger.error({
      error,
      extraData: {
        component: 'Buy It Again Bag Page Saga - fetchBuyItAgainBagPageProducts',
      },
    });
  }
}

export function* fetchBuyItAgainBagPageDrawerProducts() {
  try {
    // const biaDynamicData = yield select(getBIADynamicData);
    const biaConfigData = yield select(getBIABagpageConfigData);
    const biaAccountPageProducts = yield select(getPageProducts);
    if (biaAccountPageProducts?.length <= 0 && biaConfigData) {
      yield call(fetchBiaPageProducts, { payload: biaConfigData });
    }
  } catch (error) {
    logger.error({
      error,
      extraData: {
        component: 'Buy It Again Bag Page Saga - fetchBuyItAgainBagPageDrawerProducts',
      },
    });
  }
}

export function* fetchMoreBuyItAgainBagPageDrawerProducts() {
  try {
    const biaConfigData = yield select(getBIABagpageConfigData);
    // const biaDynamicData = yield select(getBIADynamicData);
    yield call(getMoreBuyItAgainProducts, { payload: biaConfigData });
  } catch (error) {
    logger.error({
      error,
      extraData: {
        component: 'Buy It Again Bag Page Saga - fetchMoreBuyItAgainBagPageDrawerProducts',
      },
    });
  }
}

function* BuyItAgainBagPageSaga() {
  yield takeLeading(
    BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.BUY_IT_AGAIN_BAG_PAGE_FETCH_PRODUCTS,
    fetchBuyItAgainBagPageProducts
  );
  yield takeLatest(
    BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.GET_MORE_BIA_BAGPAGE_DRAWER_PRODUCTS,
    fetchMoreBuyItAgainBagPageDrawerProducts
  );
  yield takeEvery(
    BUY_IT_AGAIN_BAG_PAGE_CONSTANTS.FETCH_BIA_BAGPAGE_DRAWER_PRODUCTS,
    fetchBuyItAgainBagPageDrawerProducts
  );
}

export default BuyItAgainBagPageSaga;
